
import HttpClienteToken from '../../services/HttpClientToken';

import { AxiosError } from 'axios';

import { HttpResponse } from '../../interfaces/auth/AuthInterface';
import { AgregarAnexosPromocionParams, GenerarAcuseParams, GenerarAcuseResponse } from '../../interfaces/comun/PromocionInterface';

export const AgregarAnexosPromocion = ( params: AgregarAnexosPromocionParams ) => {

    return new Promise<HttpResponse>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/Promocion/AgregarAnexos', params, token)
            .then( ({ data } : { data : HttpResponse } ) => {  
                resolve( data );                
            })
            .catch( ( error: AxiosError ) => {
                resolve({
                    success: false,
                    message: error.message,
                });
            });
        }

    });

}

export const GenerarAcusePromocion = ( params: GenerarAcuseParams ) => {

    return new Promise<GenerarAcuseResponse>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/Promocion/GenerarAcuse', params, token)
            .then( ({ data } : { data : GenerarAcuseResponse } ) => {  
                resolve( data );                
            })
            .catch( ( error: AxiosError ) => {
                resolve({
                    success: false,
                    message: error.message,
                });
            });
        }

    });

}